import { defineFcm } from '../shared/factory';

export const FCM_PETITION_PAGE_MEDIA_MENTIONS_CARD = defineFcm('petition_page_media_mentions_card')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-vaquita',
		scope: 'corgi-front-end',
		context: 'Petition Details Page Media Mentions',
		description:
			'Kill switch for the media mentions card experiment on the petition details page, which replaces the third-party iframely embed with a Change-owned card, independent of Experiment Service assignment.\n\nhttps://change.atlassian.net/browse/CHANGE-95727',
		import: false,
	});
